import { createStyles, makeStyles, Theme } from '../../styles/styles';

export default makeStyles((theme: Theme) => createStyles({
  readOnlyFieldWrapper: {
    width: '100%',
  },
  readOnlyFieldRow: {
    display: 'flex',
    gap: 16,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0,
    },
  },
  readOnlyFieldLabel: {
    flexBasis: '45%',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      flexBasis: 'auto',
      paddingBottom: 4,
    },
  },
  fieldErrorBox: {
    marginTop: 8,
  },
}), { name: 'ReadOnlyField' });

